import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import SignIn from "../views/SignIn.vue";
import Gallery from "../views/Gallery.vue";
import Album from "../views/Album.vue";
import AlbumDetail from "../views/AlbumDetail.vue";
import MyPhoto from "../views/MyPhoto.vue";
import MyPhotoDetail from "../views/MyPhotoDetail.vue";
import Cart from "../views/Cart.vue";
import CartDetail from "../views/CartDetail.vue";
import CartConfirm from "../views/CartConfirm.vue";
import MyPage from "../views/MyPage.vue";
import MyPageEdit from "../views/MyPageEdit.vue";
import Address from "../views/Address.vue";
import AddressAdd from "../views/AddressAdd.vue";
import AddressEdit from "../views/AddressEdit.vue";
import Payment from "../views/Payment.vue";
import PaymentAdd from "../views/PaymentAdd.vue";
import History from "../views/History.vue";
import HistoryDetail from "../views/HistoryDetail.vue";
import CommercialTransactions from "../views/CommercialTransactions.vue";
import Logout from "../views/Logout.vue";
import Secure from "../views/3dSecure.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
  },
  {
    path: "/album",
    name: "Album",
    component: Album,
  },
  {
    path: "/album/detail",
    name: "AlbumDetail",
    component: AlbumDetail,
  },
  {
    path: "/myphoto",
    name: "MyPhoto",
    component: MyPhoto,
  },
  {
    path: "/myphoto/detail",
    name: "MyPhotoDetail",
    component: MyPhotoDetail,
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
  },
  {
    path: "/cart/detail",
    name: "CartDetail",
    component: CartDetail,
  },
  {
    path: "/cart/confirm",
    name: "CartConfirm",
    component: CartConfirm,
  },
  {
    path: "/mypage",
    name: "MyPage",
    component: MyPage,
  },
  {
    path: "/mypage/edit",
    name: "MyPageEdit",
    component: MyPageEdit,
  },
  {
    path: "/address",
    name: "Address",
    component: Address,
  },
  {
    path: "/address/add",
    name: "AddressAdd",
    component: AddressAdd,
  },
  {
    path: "/address/edit",
    name: "AddressEdit",
    component: AddressEdit,
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
  },
  {
    path: "/payment/add",
    name: "PaymentAdd",
    component: PaymentAdd,
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "/history/detail",
    name: "HistoryDetail",
    component: HistoryDetail,
  },
  {
    path: "/commercial/transactions",
    name: "CommercialTransactions",
    component: CommercialTransactions,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/3dsecure",
    name: "3dSecure",
    component: Secure,
  },
  {
    path: "",
    redirect: {
      name: "SignIn",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {

  const maintenanceMode = process.env.VUE_APP_MANTENANCE_MODE;
  const toQuery = to.query;
  const fromQuery = from.query;
  const toPath = to.path;

  const isMaintenanceMode = maintenanceMode && maintenanceMode === 'true';
  const toMagicWord = toQuery.vadar && toQuery.vadar === 'anakin';
  const fromMagicWord = fromQuery.vadar && fromQuery.vadar === 'anakin';

  if (isMaintenanceMode) {
    if (toMagicWord) {
      if (toPath === '/maintenance') {
        next('/home');
        return;
      }
      next();
      return;
    }

    if (fromMagicWord) {
      // ここで to のクエリーに from のクエリーを渡す
      const query = Object.assign(to.query, { vadar: 'anakin' });
      next({ name: to.name || '', params: to.params, query });
      return;
    }

    // should go to maintenance
    if (toPath === '/maintenance') {
      next();
      return;
    }
    next('/maintenance');
    return;
  }

  // maintenanceMode = false
  if (toPath === '/maintenance') {
    next('/home');
    return;
  }

  if (
    to.path === '/signin'
  ) {
    next();
  } else {
    next();
    return;
  }

});

export default router;
